<form [formGroup]="reasonForm" novalidate (ngSubmit)="reasonForm.valid && confirm()">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">
        {{title}}
      </h4>
      <button type="button" class="close" (click)="cancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group row">
        <label class="col-md-3 col-form-label" for="reasonCode"><b>Seleccione un motivo</b></label>
        <div class="col-md-9">
          <select type="text" id="reasonCode" name="reasonCode" class="form-control" formControlName="reasonCode"
            [class.is-invalid]="(reasonForm.get('reasonCode')?.touched || reasonForm.get('reasonCode')?.dirty) && reasonForm.get('reasonCode')?.invalid"
            (change)="changeType()">
            <option *ngFor="let reason of this.reasons" [value]="reason.code">{{reason.description}}</option>
          </select>
        </div>
        <div class="invalid-feedback">Por favor seleccione un motivo</div>
      </div>
      <div class="form-group row" *ngIf="selectedReason?.isTextFreeDescription">
        <label class="col-md-3 col-form-label" for="manualReasonDescription"><b>Ingrese un motivo</b></label>
        <div class="col-md-9">
          <input type="text" id="manualReasonDescription" name="manualReasonDescription" class="form-control"
            formControlName="manualReasonDescription"
            [class.is-invalid]="(reasonForm.get('manualReasonDescription')?.touched || reasonForm.get('manualReasonDescription')?.dirty) && reasonForm.get('manualReasonDescription')?.invalid"
            autocomplete="off">
        </div>
      </div>
      <div *ngIf="selectedReason?.requirePhoneNumber">
        <div class="form-group row">
          <label class="col-md-3 col-form-label" for="knowsOwnerPhone"><b>¿Sabe el numero del dueño de la
              cuenta?</b></label>
          <div class="col-md-9">
            <select type="text" id="knowsOwnerPhone" name="knowsOwnerPhone" class="form-control"
              formControlName="knowsOwnerPhone"
              [class.is-invalid]="(reasonForm.get('knowsOwnerPhone')?.touched || reasonForm.get('knowsOwnerPhone')?.dirty) && reasonForm.get('knowsOwnerPhone')?.invalid"
              autocomplete="off">
              <option value="true">Si</option>
              <option value="false">No</option>
            </select>
          </div>
        </div>
        <div class="form-group row" *ngIf="knowsOwnerPhone">
          <label class="col-md-3 col-form-label" for="ownerPhone"><b>Ingrese numero celular del dueño de la
              cuenta:</b></label>
          <div class="col-md-9">
            <input type="text" id="ownerPhone" name="ownerPhone" class="form-control" formControlName="ownerPhone"
              [class.is-invalid]="(reasonForm.get('ownerPhone')?.touched || reasonForm.get('ownerPhone')?.dirty) && reasonForm.get('ownerPhone')?.invalid"
              autocomplete="off" [mask]="phoneMask" [showMaskTyped]="true">
          </div>
        </div>
      </div>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
      <button type="submit" class="btn btn-outline-primary">Confirmar</button>
    </div>
  </div>
</form>